import { Link } from 'react-router-dom';
import type { DetailItem, ResolvedIssueLink } from '../types/content';
import { getCategoryLabel, getTopicPath } from '../lib/contentUtils';
import type { WebsiteContent } from '../types/content';

export function RelatedTopics({
  data,
  items,
  issueLinks,
  context,
}: {
  data: WebsiteContent;
  items: DetailItem[];
  issueLinks: ResolvedIssueLink[];
  context?: { highLevelSlug: string; specificSlug: string };
}) {
  if (items.length === 0 && issueLinks.length === 0) return null;

  return (
    <aside className="related-topics">
      <h3>Also relevant under</h3>
      <p className="related-hint">Cross-cutting voter issues connected to this entry</p>

      {issueLinks.length > 0 && (
        <ul className="issue-link-list">
          {issueLinks.map((link) => (
            <li key={link.specificIssueId}>
              <Link to={`/issues/${link.highLevelSlug}/${link.specificSlug}`}>
                <span className="related-title">{link.specificTitle}</span>
                <span className="related-meta">{link.highLevelTitle}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}

      {items.length > 0 && (
        <>
          <h4 className="related-subheading">Related entries</h4>
          <ul>
            {items.map((item) => (
              <li key={item.id}>
                <Link to={getTopicPath(data, item, context)}>
                  <span className="related-title">{item.title}</span>
                  <span className="related-meta">{getCategoryLabel(item.category)}</span>
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
    </aside>
  );
}
